import {
  pathOr,
  set,
  lensPath,
  equals,
  append,
  cond,
  always,
  T,
  includes,
  find,
  findIndex,
  path
} from 'ramda';
import { compose } from 'recompose';
import { getValidators } from '../Validators/validators';
import { getFormatters } from '../Formatters/formatters';
import {
  timeStampInISOFormat,
  humanizeUTCDateWithoutTimeZone,
} from 'src/utilities/formatDate';
import { isEmptyOrNil, isNotEmpty, returnIsNotEmptyOrTrue } from 'src/utilities/hasValue';
import { pruneAddress } from 'src/utilities/properties';
import store from 'src/store';
import {
  updateUserSpecificIntent
} from 'src/store/siteConfigurator/userSpecificIntent/userSpecificIntent.requests';
import { META_DATA, NALIST, NULL_DASH } from 'src/services/constants';
import { mkAutoAnswerQuestion } from 'src/features/core/ChatEngine/Configs/autoAnswerConfigurator';
import { FALSE, TRUE } from 'src/constants';
import { updateIntentApiResourceFn } from 'src/features/core/ChatEngine/Bot/SimpleBotApiService';
import { getAdjustedWithPreBulitAnswerForThisQuestion, hasAnsweredYesToOnBehalfCoBorrower } from 'src/features/core/ChatEngine/Bot/simpleBotServiceUtil';

import { HAS_DECLINED_BY_RULE_CONTEXT } from 'src/features/constants';
import { updateUserSpecificIntentInSession } from 'src/store/siteConfigurator/userSpecificIntent/userSpecificIntent.sessions';
import { DE_ACTIVATED_UPON, IS_HIDE_THIS_INTENT, IS_MASK_THIS_INTENT_COND, SHOULD_HIDE_PROGRESS, SHOULD_HIDE_STEPPER } from '../../Intents/intentConstants';
import { SurveyIntents } from '../Configs/SurveyIntents';
import { isAnsweringFor3rdPerson } from 'src/utilities/storage';
import { getStateFromStore } from './stateStore';



const getIsRedactField = (intent: any) => {
  if (
    equals('true', pathOr('false', [META_DATA, 'is_redact_the_field'], intent))
  ) {
    return pathOr('X', [META_DATA, 'redact_letter'], intent);
  }
  return '';
};

/**
 * getModificationWithBotService - this is a bot servie where the intetn gets alteration and formatter ,validator,redact
 * etc options are added for given set of intents
 * it will have a action call where after ever question answered action gets triggered
 * @param singleSiteIntent single Site intent configured for site
 * @param singelUserSpecificIntent single user intents is from user intents record
 * @param userSpecificIntent its a overall user intents record
 * @param siteIntents is a overall configured site intents for selected Product flow
 * @param updateUserSpecificIntentFn this is update of a user intents record
 TODO:
 */
export const getModificationWithBotService = (
  dispatch: any,
  singleSiteIntent: any,
  singelUserSpecificIntent: any,
  userSpecificIntent: any,
  siteIntents: any,
  updateUserSpecificIntentFn: any,
  updateWorkflowLoading: any
) => {
  const storeState = getStateFromStore(singleSiteIntent)
  const mergedIntent = { ...singelUserSpecificIntent, ...singleSiteIntent }
  const answer = pathOr(
    '',
    ['answer'],
    mkAutoAnswerQuestion(
      mergedIntent,
      storeState
    )
  );
  const isBorrowerAnsweringOnBehalfCo = hasAnsweredYesToOnBehalfCoBorrower(siteIntents)
  const intentQuestion = pathOr('', [META_DATA, 'display_content_as'], singleSiteIntent) ||
    pathOr('', ['question'], singleSiteIntent)
    const question3rdPerson = pathOr('', [META_DATA, 'question_3rd_person'], singleSiteIntent)

  const shouldShowThirdPartyQuestion = isBorrowerAnsweringOnBehalfCo && isAnsweringFor3rdPerson() && isNotEmpty(question3rdPerson);
  const questionString =  shouldShowThirdPartyQuestion ? question3rdPerson : intentQuestion;

  const question = getAdjustedWithPreBulitAnswerForThisQuestion(
    questionString,
    siteIntents,
    storeState
  )

  return {
    question,
    redactTheText: getIsRedactField(singleSiteIntent),
    inputRefKeyField: pathOr('', ['inputRefKeyField'], singleSiteIntent),
    otherOptions: pathOr('', ['otherOptions'], singleSiteIntent),
    multiOptionType: pathOr('', ['multiOptionType'], singleSiteIntent),
    api_resource: pathOr('', ['api_resource'], singleSiteIntent),
    defaultProduct: pathOr('purchase', ['defaultProduct'], singleSiteIntent),
    option_tag_ref: pathOr('', ['option_tag_ref'], singleSiteIntent),
    api_initial_path: pathOr('', ['api_initial_path'], singleSiteIntent),
    dropdownType: pathOr('', ['dropdownType'], singleSiteIntent),
    // TODO: needs to remove all helperText on existing flow have to use common flag helper_text
    helperText: pathOr('', ['helperText'], singleSiteIntent) || pathOr('', ['helper_text'], singleSiteIntent),
    dropdownLabel: pathOr('', ['dropdownLabel'], singleSiteIntent),
    intentType: pathOr('', ['intent_type'], singleSiteIntent),
    questionType: pathOr('', ['question_type'], singleSiteIntent),
    question_id: pathOr('', ['question_id'], singleSiteIntent),
    name: pathOr('', ['name'], singleSiteIntent),
    category: pathOr('', ['category'], singleSiteIntent),
    slider: pathOr('', ['slider'], singleSiteIntent),
    endDealData: pathOr([], ['endDealData'], singleSiteIntent),
    declineReason: pathOr('', ['declineReason'], singleSiteIntent),
    has_move_to_next: pathOr('', ['has_move_to_next'], singleSiteIntent),
    save_mortgage_balance: pathOr(false, ['save_mortgage_balance'], singleSiteIntent),
    autoSavedAnswer: pathOr('', ['autoSavedAnswer'], singleSiteIntent),
    pipe_with: pathOr('', ['pipe_with'], singleSiteIntent),
    single_resource: pathOr('', ['single_resource'], singleSiteIntent),
    upsellDetails: pathOr({}, ['upsell'], singleSiteIntent),
    dateSettings: pathOr({
      minYear: "1800",
      maxYear: "currentYear"
    }, ['dateSettings'], singleSiteIntent),
    should_invalidate_and_save: pathOr(
      false,
      ['should_invalidate_and_save'],
      singleSiteIntent
    ),
    answer,
    options: [
      {
        validator: getValidators(
          pathOr('', ['validators'], singleSiteIntent),
          pathOr('', ['validator_message'], singleSiteIntent),
          storeState,
          singleSiteIntent
        ),
        formatter: getFormatters(pathOr('', ['formatter'], singleSiteIntent)),
        options: pathOr({}, ['options'], singleSiteIntent),
        action: (
          answer: any,
          hideThisIntent: boolean = false,
          hasRuleDeclined: boolean = false
        ) => {
          const args = {
            dispatch,
            singleSiteIntent,
            userSpecificIntent,
            siteIntents,
            updateUserSpecificIntentFn,
            updateWorkflowLoading
          }
          return singleIntentAction(
            args,
            answer,
            hideThisIntent,
            hasRuleDeclined
          )
        }
      },
    ],
    question_created_by: 15215884554888888,
    key_field: pathOr('', ['key_field'], singleSiteIntent),
    [DE_ACTIVATED_UPON]: pathOr('', [DE_ACTIVATED_UPON], singleSiteIntent),
    [IS_MASK_THIS_INTENT_COND]: pathOr(
      '',
      [IS_MASK_THIS_INTENT_COND],
      singleSiteIntent
    ),
    [IS_HIDE_THIS_INTENT]: pathOr(
      false,
      [IS_HIDE_THIS_INTENT],
      singleSiteIntent
    ),
    [SHOULD_HIDE_STEPPER]: pathOr(false, [SHOULD_HIDE_STEPPER], singleSiteIntent),
    [SHOULD_HIDE_PROGRESS]: pathOr(false, [SHOULD_HIDE_PROGRESS], singleSiteIntent),
    created_at: pathOr('', ['created_at'], singelUserSpecificIntent),
    updated_at: pathOr('', ['updated_at'], singelUserSpecificIntent),
    [META_DATA]: pathOr({}, [META_DATA], singleSiteIntent),
    save_in_api_field: pathOr([], ['save_in_api_field'], singleSiteIntent),
    api_context: pathOr([], ['api_context'], singleSiteIntent),
    uw_decision: pathOr([], ['uw_decision'], singleSiteIntent),
    event_context: pathOr([], ['event_context'], singleSiteIntent),
    pre_event_context: pathOr([], ['pre_event_context'], singleSiteIntent),
    status_context: pathOr([], ['status_context'], singleSiteIntent),
    audit_activity_context: pathOr([], ['audit_activity_context'], singleSiteIntent),

    rule_context: pathOr([], ['rule_context'], singleSiteIntent),
    match_in_api: pathOr('', ['match_in_api'], singleSiteIntent),
    skip_upload: pathOr(true, ['skip_upload'], singleSiteIntent),
    show_tooltip: pathOr(false, ['show_tooltip'], singleSiteIntent),
    hyperlink_popup_modals: pathOr([], ['hyperlink_popup_modals'], singleSiteIntent),
    has_disable_previous: pathOr(
      false,
      ['has_disable_previous'],
      singleSiteIntent
    ),
    is_sub_products: pathOr(false, ['is_sub_products'], singleSiteIntent),
    multiple_loan: pathOr(false, ['multiple_loan'], singleSiteIntent),
    has_disable_summary_edit: pathOr(
      false,
      ['has_disable_summary_edit'],
      singleSiteIntent
    ),
    hasDeclinedByRuleContext: equals(pathOr(
      FALSE,
      [META_DATA, HAS_DECLINED_BY_RULE_CONTEXT],
      singelUserSpecificIntent
    ), TRUE),
    emails: pathOr([], ['emails'], singleSiteIntent),
    question_header: getAdjustedWithPreBulitAnswerForThisQuestion(
      pathOr('', [META_DATA, 'question_header'], singleSiteIntent),
      siteIntents,
      storeState
    ),
  };
};

// TODO: we need to make the above method's retrun type as class WorkflowIntent
export type WorkflowBotIntent = ReturnType<typeof getModificationWithBotService>


/**
 singleIntentAction is used to be called when user hit next on a question
*/

const singleIntentAction = async (
  args: {
    dispatch: any,
    singleSiteIntent: any,
    userSpecificIntent: any,
    siteIntents: any[],
    updateUserSpecificIntentFn: any,
    updateWorkflowLoading: any,
  },
  answer: any,
  hideThisIntent: boolean,
  hasRuleDeclined: boolean
) => {
  const {
    dispatch,
    singleSiteIntent,
    userSpecificIntent,
    siteIntents,
    updateUserSpecificIntentFn,
    updateWorkflowLoading
  } = args
  const storeState = getStateFromStore(singleSiteIntent)
  const loanApp = path(['loanApp'],storeState)

  const setIntentAnswer = (_answer: any) => {
    const answeredUserSpecificIntent = mkUserIntentObject(
      userSpecificIntent,
      singleSiteIntent,
      String(_answer),
      hideThisIntent,
      hasRuleDeclined
    )
    const surveyIntents = new SurveyIntents(siteIntents, answeredUserSpecificIntent, loanApp)
    const cleanedUpUserSpecificIntent = surveyIntents.activatedUserSpecificIntent()
    return cleanedUpUserSpecificIntent
  }

  const updateAnswer = (_answer: any) => {
    updateUserSpecificIntentFn(
      setIntentAnswer(_answer)
    )
  }

  const updateAPIResource = (_answer: any) => {
    return updateIntentApiResourceFn(
      dispatch,
      _answer,
      userSpecificIntent,
      singleSiteIntent,
      siteIntents,
      storeState,
      () => setIntentAnswer(_answer),
      updateWorkflowLoading
    )
  }

  const answerModificationForQuestionType = getFormatAttachedForThisAnswer(
    answer,
    pathOr('', ['question_type'], singleSiteIntent),
    pathOr('', ['formatter'], singleSiteIntent)
  );
  try {
    const res = await Promise.all([answerModificationForQuestionType] as any);
    const [_answer_4] = res;
    Promise.all([updateAPIResource(_answer_4)] as any)
      .then((_resp: any) => { })
      .catch((_err: any) => {
        updateAnswer(answerModificationForQuestionType);
      });
  } catch (_err_) {
    updateAPIResource(answerModificationForQuestionType);
  }

}


/**
 * getFormatAttachedForThisAnswer - basically it will attach the formatter or any like zip code for answer it will attach
 * with the answer after being answered or updated
 * @param answer  can have answer
 * @param questionType can have question type
 */
const getFormatAttachedForThisAnswer = (
  answer: any,
  questionType: any,
  formatType: any
) => {
  let modifyAnswer = '';
  if (includes(answer, NALIST)) {
    modifyAnswer = NULL_DASH;
  } else {
    modifyAnswer = cond([
      [equals('PERCENT_FORMATTER_WITHOUT_SYMBOL'), () => `${answer}%`],
      [
        equals('NUMBER_FORMATTER'),
        () => {
          return String(answer);
        },
      ],
      [T, always(String(answer))],
    ])(formatType);
  }

  return cond([
    [equals('DATE'), () => humanizeUTCDateWithoutTimeZone(modifyAnswer, {})],
    [equals('ADDRESS'), () => getAddressModifications(modifyAnswer)],
    [T, always(modifyAnswer)],
  ])(questionType);
};

export const getAddressModifications = (address: any) => {
  if (includes(address, NALIST)) {
    return NULL_DASH;
  } else {
    return address;
  }
};

/**
 * mkUserIntentObject - this method will make a user intent object and compose it if found already then will update
 * if not it will create another record
 * @param userSpecificIntent data is the intent record that needs to updated or created for user intent record
 * @param siteIntent can have a single site intent or localStateIntent (class intent)
 * @param answer can have a answer
 * @param hideThsIntent can have a value to hide this intent if given true it will get hidden from UI
 */
export const mkUserIntentObject = (
  userSpecificIntent: any,
  siteIntent: any,
  answer?: string,
  hideThsIntent?: boolean,
  hasRuleDeclined?: boolean
) => {

  const newIntentObject: any = compose(
    setMetadataIfKeyOrValueNotEmpty(HAS_DECLINED_BY_RULE_CONTEXT, hasRuleDeclined),
    setIfKeyOrValueNotEmpty('is_hide_this_intent', hideThsIntent)
  )({
    answer,
    question_id: String(pathOr('', ['question_id'], siteIntent)),
    // TODO: needs to deprecate save metdata on db
    metadata: pathOr({}, ['metadata'], siteIntent),
    key_field: pathOr('', ['key_field'], siteIntent),
    created_at: timeStampInISOFormat(),
    updated_at: timeStampInISOFormat(),
  })

  const checkForSameIntentId = (intent: any) => equals(
    String(pathOr('', ['question_id'], intent)),
    String(pathOr('', ['question_id'], siteIntent))
  );
  const useIntents = pathOr([], ['intents'], userSpecificIntent)
  const existingIntent = find(checkForSameIntentId)(useIntents);

  if (isEmptyOrNil(existingIntent)) {
    const updatedIntentData = append(
      newIntentObject,
      useIntents
    );

    return compose(
      set(lensPath(['intents']), updatedIntentData)
    )(userSpecificIntent);
  }
  const indexOfIntent = findIndex(checkForSameIntentId)(useIntents);

  const mutatedIntent = compose(
    set(lensPath(['updated_at']), timeStampInISOFormat()),
    set(lensPath(['answer']), answer),
    set(lensPath(['metadata']), pathOr({}, ['metadata'], newIntentObject)),
  )(existingIntent)

  return compose(
    set(lensPath(['intents', indexOfIntent]), mutatedIntent)
  )(userSpecificIntent);
};

export const setIfKeyOrValueNotEmpty = (key: any, keyValue: any) => {
  if (isEmptyOrNil(key) || isEmptyOrNil(keyValue) || equals(false, keyValue)) {
    return (data: any) => data;
  }
  return (data: any) => {
    return returnIsNotEmptyOrTrue(
      keyValue,
      set(
        lensPath([key]),
        keyValue
      )(data),
      data
    )
  };

}

export const setMetadataIfKeyOrValueNotEmpty = (key: any, keyValue: any) => {
  if (isEmptyOrNil(key) || isEmptyOrNil(keyValue) || equals(false, keyValue)) {
    return (data: any) => data;
  }
  return (data: any) => {
    return returnIsNotEmptyOrTrue(
      keyValue,
      set(
        lensPath([META_DATA, key]),
        `${keyValue}`
      )(data),
      data
    )
  };
};

/**
updateUserSpecificIntentForThisIntent is used to update
answer on current intent and by default make this intent as not active
if we send isThisIntentActive to make intent as active true
*/
export const updateUserSpecificIntentForThisIntent = (
  thisIntent: any,
  userSpecificIntent: any,
  answer: string,
  hideStatus: boolean = false,
  _isThisIntentActive: boolean = false // TODO needs to remove
) => {
  const payload = mkUserIntentObject(
    userSpecificIntent,
    thisIntent,
    answer,
    hideStatus
  )

  return store.dispatch<any>(updateUserSpecificIntent(payload))
};

export const updateUserSessionIntent = (
  intent: any,
  userSpecificIntent: any,
  answer: string,
  hideStatus: boolean = false,
  _isThisIntentActive: boolean = false, // Needs to remove
  shouldDispatch: boolean = true
) => {
  const payload = mkUserIntentObject(
    userSpecificIntent,
    intent,
    answer,
    hideStatus
  )
  return shouldDispatch ?
    store.dispatch<any>(updateUserSpecificIntent(payload)) :
    updateUserSpecificIntentInSession(payload)
}

export const updateUserSpecificIntentMoveToNextAsPromise = (
  intent: any,
  userSpecificIntent: any,
  answer: string,
  dispatch: any,
  _isThisIntentActive: boolean = false // needs to remove
) => {

  return dispatch(updateUserSpecificIntent(mkUserIntentObject(
    userSpecificIntent,
    intent,
    answer,
    false
  )))
};

export const getAddressModificationForProperty = (
  address: any,
  place_id: any
) => {
  if (includes(address, NALIST)) {
    return NULL_DASH;
  } else {
    return pruneAddress(address);
  }
};
